export * from "./extension.js";
export * from "./ladata/index.js";
export * from "./login/index.js";
export * from "./ambassador-ad-affiliation.js";

import { reportAmbassadorAdAffiliation } from "./ambassador-ad-affiliation.js";
import { identifyPosthogUser, trackLinkClicks } from "./ladata/index.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", async () => {
    const userConnected = await identifyPosthogUser();
    trackLinkClicks(userConnected);
    reportAmbassadorAdAffiliation();
  });
} else {
  (async () => {
    const userConnected = await identifyPosthogUser();
    trackLinkClicks(userConnected);
    reportAmbassadorAdAffiliation();
  })();
}
